import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthorizationService } from '~ngx-shared/authentication';

@Injectable()
export class RoleInterceptor implements HttpInterceptor {
  private readonly authorizationService = inject(AuthorizationService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isHasuraOrExternal = this.authorizationService.isAuthenticationUrl(request.url);
    const currentRole = this.authorizationService.authorizationStore.value.currentRole;

    if (!isHasuraOrExternal || !currentRole) {
      return next.handle(request);
    }

    return next.handle(
      request.clone({
        headers: request.headers.set('x-hasura-role', currentRole)
      })
    );
  }
}
